import { render } from "./MessageView.vue?vue&type=template&id=26b2636a"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=26b2636a&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__